import React from 'react';
import {ChatBotProvider} from 'react-chatbotify';
import I18nProvider from '../I18nProvider';
import {
  AnimationsContextProvider,
  ButtonSendChatHistoryContextProvider,
  GlobalContextProvider,
  NewUserChatContextProvider,
  NoUserChatContextProvider,
  ReturningUserChatContextProvider,
  useNewUserChatContext,
  useNoUserChatContext,
  UserContextProvider,
  useReturningUserChatContext,
} from '../../contexts';
import ChatManager from '../ChatManager';
import Chat from '../Chat';
import HelloImage from '../Animations/HelloImage';
import ThinkingImage from '../Animations/ThinkingImage';
import DogImage from '../Animations/DogImage';
import RestaurantImage from '../Animations/RestaurantImage';
import WinterImage from '../Animations/WinterImage';
import WaterImage from '../Animations/WaterImage';
import styles from './App.module.scss';

export const App = () => {
  return (
    <div className={styles.appContainer} dir={process.env.REACT_APP_MODE === 'testing' ? 'ltr' : 'rtl'}>
      <GlobalContextProvider>
        <ChatBotProvider>
          <AnimationsContextProvider>
            <HelloImage/>
            <ThinkingImage/>
            <DogImage/>
            <RestaurantImage/>
            <WinterImage/>
            <WaterImage/>
            <I18nProvider>
              <UserContextProvider>
                <ButtonSendChatHistoryContextProvider>
                  <ChatManager
                    newUserChat={(
                      <NewUserChatContextProvider>
                        <Chat useContext={useNewUserChatContext}/>
                      </NewUserChatContextProvider>
                    )}
                    returnedUserChat={(
                      <ReturningUserChatContextProvider>
                        <Chat useContext={useReturningUserChatContext}/>
                      </ReturningUserChatContextProvider>
                    )}
                    noUserChat={(
                      <NoUserChatContextProvider>
                        <Chat useContext={useNoUserChatContext}/>
                      </NoUserChatContextProvider>
                    )}
                  />
                </ButtonSendChatHistoryContextProvider>
              </UserContextProvider>
            </I18nProvider>
          </AnimationsContextProvider>
        </ChatBotProvider>
      </GlobalContextProvider>
    </div>
  );
};
